require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/fn/regexp/escape.js
// module id = 916
// module chunks = 0